import React from 'react';
import { Language } from '../App';
import { PageHero } from '../components/PageHero';
interface PrivacyPolicyProps {
  language: Language;
}
export function PrivacyPolicy({
  language
}: PrivacyPolicyProps) {
  const isPashto = language === 'pashto';
  const sections = isPashto ? [{
    title: 'معلوماتو راټولول',
    text: 'کله چې تاسو زموږ ویبپاڼه کاروئ، موږ ممکن ستاسو نوم، بریښنالیک پته او د اړیکې معلومات راټول کړو کله چې تاسو خپله خوښه یې ورکوئ، لکه د ګډون یا اړیکې فورم ډکولو پر مهال.'
  }, {
    title: 'د معلوماتو کارول',
    text: 'ستاسو شخصي معلومات یوازې د ګډون اداره کولو، ستاسو پوښتنو ته ځواب ورکولو او زموږ خدماتو ښه کولو لپاره کارول کیږي. موږ ستاسو معلومات دریمو اړخونو ته نه پلورو او نه یې شریکوو.'
  }, {
    title: 'کوکیز',
    text: 'زموږ ویبپاڼه ممکن کوکیز وکاروي ترڅو ستاسو تجربه ښه کړي. کوکیز کوچنۍ فایلونه دي چې ستاسو وسیله کې زیرمه کیږي. تاسو کولای شئ د خپل براوزر ترتیباتو له لارې کوکیز بند کړئ.'
  }, {
    title: 'د معلوماتو خوندیتوب',
    text: 'موږ ستاسو شخصي معلوماتو د ساتنې لپاره مناسبه ګامونه پورته کوو. خو هیڅ انټرنیټي لیږد یا بریښنایي ذخیره بشپړ خوندي نه ده.'
  }, {
    title: 'دریمو اړخونو لینکونه',
    text: 'زموږ ویبپاڼه ممکن نورو ویبپاڼو ته لینکونه ولري. موږ د دریمو اړخونو ویبپاڼو د محرمیت تګلارو مسؤل نه یو.'
  }, {
    title: 'بدلونونه',
    text: 'موږ ممکن دا محرمیت پالیسي وخت په وخت تازه کړو. هر بدلون به په دې پاڼه کې خپور شي.'
  }] : [{
    title: 'Information Collection',
    text: 'When you use our website, we may collect your name, email address, and contact information when you voluntarily provide it, such as when filling out a contact or support form.'
  }, {
    title: 'Use of Information',
    text: 'Your personal information is used solely for responding to your enquiries and improving our services. We do not sell or share your information with third parties.'
  }, {
    title: 'Cookies',
    text: 'Our website may use cookies to improve your experience. Cookies are small files stored on your device. You can disable cookies through your browser settings.'
  }, {
    title: 'Data Security',
    text: 'We take reasonable steps to protect your personal information. However, no internet transmission or electronic storage is completely secure.'
  }, {
    title: 'Third-Party Links',
    text: 'Our website may contain links to other websites. We are not responsible for the privacy practices of third-party websites.'
  }, {
    title: 'Changes',
    text: 'We may update this privacy policy from time to time. Any changes will be posted on this page.'
  }];
  return <div className="pt-24 md:pt-28" data-id="element-619">
      <PageHero language={language} titleEn="Privacy & Cookie Policy" titlePs="محرمیت او کوکي پالیسي" introEn="How we collect, use, and protect your personal information." introPs="موږ ستاسو شخصي معلومات څنګه راټولوو، کاروو او ساتو." data-id="element-620" />

      <section className="py-20 bg-white px-6" data-id="element-621">
        <div className="max-w-3xl mx-auto space-y-10" data-id="element-622">
          {sections.map((section, idx) => <div key={idx} className="border-b border-gray-100 pb-8 last:border-0" data-id="element-623">
              <h3 className={`text-xl font-bold text-pasoon-dark mb-3 ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-624">
                {section.title}
              </h3>
              <p className={`text-gray-600 ${isPashto ? 'font-pashto leading-loose' : 'leading-relaxed'}`} data-id="element-625">
                {section.text}
              </p>
            </div>)}
        </div>
      </section>
    </div>;
}